import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, shareReplay } from 'rxjs';
import { BaseDatasource } from '@shared/base/base.datasource';
import { BaseService, IBaseServiceConfig } from '@services/base-service.service';
import { TableColumn } from '@shared/interface/table.interface';

export interface IParameterTable {
  size?: number;
  page?: number;
}

@Injectable({
  providedIn: 'root',
})
export abstract class BaseTableService<T> {
  responseDatabase: BehaviorSubject<BaseDatasource<T>> = new BehaviorSubject<BaseDatasource<T>>(new BaseDatasource<T>());
  responseDatabase$: Observable<BaseDatasource<T>>;

  data: T[] = [{}, {}, {}, {}, {}] as T[]; // for loader

  protected constructor(private baseService: BaseService) {
    this.responseDatabase$ = this.responseDatabase.asObservable();
  }

  loadDataTable(url: string, parameterFilter: string, config?: IBaseServiceConfig) {
    const baseDatasource = new BaseDatasource<T>();

    baseDatasource.isPreloadTextViewedSubject.next(true);
    baseDatasource.isFinishLoadingSubject.next(false);
    baseDatasource.hasItems = false;
    baseDatasource.tableSubject.next(this.data);

    this.baseService
      .getData<T[]>(url + parameterFilter, config)
      .pipe(shareReplay())
      .subscribe((value) => {
        if (!value) return;

        if (value && !value.success) {
          baseDatasource.tableSubject.next([]);
          baseDatasource.isFinishLoadingSubject.next(true);
          return;
        }

        baseDatasource.isPreloadTextViewedSubject.next(false);
        baseDatasource.isFinishLoadingSubject.next(value && value.success);
        baseDatasource.hasItems = value && value.data.length > 0;
        baseDatasource.totalItem = value.total_data ?? value.data?.length;
        baseDatasource.current_page = value.current_page ?? 0;
        baseDatasource.pageSize = value.page_size ?? 0;
        baseDatasource.totalPage = value.total_page ?? 0;
        baseDatasource.tableSubject.next(value.data);
        baseDatasource.totalItem$.next(value.total_data ?? value.data.length);
      });

    this.responseDatabase.next(baseDatasource);
  }

  loadDataTableDummy(data: any[]) {
    const baseDatasource = new BaseDatasource<T>();

    baseDatasource.isPreloadTextViewedSubject.next(true);
    baseDatasource.isFinishLoadingSubject.next(false);
    baseDatasource.hasItems = false;
    baseDatasource.tableSubject.next(this.data);

    baseDatasource.isPreloadTextViewedSubject.next(false);
    baseDatasource.isFinishLoadingSubject.next(true);
    baseDatasource.hasItems = data && data.length > 0;
    baseDatasource.totalItem = data?.length;
    baseDatasource.current_page = 0;
    baseDatasource.pageSize = 0;
    baseDatasource.totalPage = 0;
    baseDatasource.tableSubject.next(data);
    baseDatasource.totalItem$.next(data.length);

    this.responseDatabase.next(baseDatasource);
  }

  mapperDisplayColumn(data: TableColumn[]) {
    return data.map((item) => item.key);
  }
}
